﻿'use strict';

angular.module('ntmApp').factory('RescheduleActivityLeeWayValidator', [function () {

    function RescheduleActivityLeeWayValidator(activity, targetDate) {

        this.activity = activity;
        this.targetDate = targetDate;

        this.isValid = function () {
            var plannedDate = moment(this.activity.datePlanned);
            var targetScheduleDate = moment(this.targetDate);

            var afterLeewayDate = moment(plannedDate).add(this.activity.afterLeeway, 'days');
            var beforeLeewayDate = moment(plannedDate).subtract(this.activity.beforeLeeway, 'days');


            return this.activity.recurrs === 'Weekly' || this.activity.recurrs === 'Monthly' || this.activity.recurrs === 'Yearly' ?
                        !(afterLeewayDate.isBefore(targetScheduleDate) || beforeLeewayDate.isAfter(targetScheduleDate)) :
                        true;
        };

        this.warningMessage = function () {

            var plannedDate = moment(this.activity.datePlanned);
            var targetScheduleDate = moment(this.targetDate);

            var minPlannedDate = moment(plannedDate).subtract(this.activity.beforeLeeway, 'days');
            var maxPlannedDate = moment(plannedDate).add(this.activity.afterLeeway, 'days');

            return "Warning: this activity's leeway is between {0} and {1}. <br /><br /> Move activity to {2} anyway?"
                   .format(minPlannedDate.format('MM/DD/YYYY'), maxPlannedDate.format('MM/DD/YYYY'), targetScheduleDate.format('MM/DD/YYYY'));
        };
    }

    return (RescheduleActivityLeeWayValidator);
}]);